// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "-" + {"360":"d972ec22","876":"c2ba6494"}[chunkId] + ".css";
};